import { render, staticRenderFns } from "./MaterialBasePage.vue?vue&type=template&id=729c1cf2&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./MaterialBasePage.vue?vue&type=script&lang=js&"
export * from "./MaterialBasePage.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBasePage.vue?vue&type=style&index=0&id=729c1cf2&lang=scss&scoped=true&"
import style1 from "./MaterialBasePage.vue?vue&type=style&index=1&id=729c1cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c1cf2",
  null
  
)

export default component.exports